/**
 * @param {Event} event
 */
export default function stopPropagation(event) {
    event?.stopPropagation?.();
}